export const fetchEncodedData = async (url) => {
    return fetchStatsData(encodeURI(url));
};

export const fetchStatsData = async (url) => {
    const response = await fetch(url);
    return response.json();
};

export default {
    fetchEncodedData,
    fetchStatsData,
};
